import { render, staticRenderFns } from "./codiagDiag.vue?vue&type=template&id=4b190336&scoped=true"
import script from "./codiagDiag.vue?vue&type=script&lang=js"
export * from "./codiagDiag.vue?vue&type=script&lang=js"
import style0 from "./codiagDiag.vue?vue&type=style&index=0&id=4b190336&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b190336",
  null
  
)

export default component.exports